import axios from "@/axios";
import {Cuenta} from 'portalba360';

export const state = {
    empresas: [],
    cuentas: [],
    cuenta: new Cuenta(),
    cuentaSeleccionada: {}
};
export const mutations = {
    add(state, empresas) {
        state.empresas = empresas;
    },
    selectAcount(state, rut) {
        state.cuentaSeleccionada = state.cuentas.find(
            (empresa) => empresa.value == rut
        );
    },
    addAcounts(state, data) {

        state.cuentas = data.data.map(acounts => {
            let rut;
            if(acounts.identificador.includes('-') ){
                const identifierSplited = acounts.identificador.split('-');
                rut = parseInt(identifierSplited[0]);
            } else {
                rut = parseInt(acounts.identificador);
            }
            return {
                id: acounts.id,
                selectLabels: `${rut} - ${acounts.razonsocial}`,
                text: acounts.razonsocial,
                tipo: acounts.cf.tipo_consulta ? acounts.cf.tipo_consulta : "",
                value: rut,
            };
        });
    }
};
export const getters = {
    empresas: state => state.empresas,
    cuentaSeleccionada: state => state.cuentaSeleccionada,
    cuentas: state => state.cuentas,
};
export const actions = {
    async getEmpresas({commit, state}, rut) {
        try {
            const data = await state.cuenta.all();
            commit('addAcounts', data);
            commit('selectAcount', state.cuentas[0].value);
            if (rut.includes('-')){
                rut = rut.split('-')[0];
            }
            const response = await axios.get('/GetEmpresasByContacto',{ params: { rutContacto: rut } } );
            const empresas = response.data.datos;
            commit('add', empresas);
            return empresas;
        } catch (e) {
            return console.log(e)
        }
    },
    selectAcount({commit}, rut) {
        try {
            commit('selectAcount', rut);
        } catch (e) {
            return console.log(e)
        }
    }
};